export default async ({ store }) => {
  if (!store.state.currentUser && store.state.accessToken) {
    try {
      await store.dispatch('setCurrentUser')
    } catch (error) {
      // 握りつぶし
    }
  }
}
